import { ComponentProps } from 'react';
import Tooltip from 'components/Tooltip';
import EyeClosedImg from 'assets/common/eye-closed.svg?react';

type Props = ComponentProps<'svg'> & {
  tooltip: string;
  qaSelector?: string;
};

function HideIcon({ tooltip, qaSelector, ...rest }: Props) {
  return (
    <Tooltip title={`Hide ${tooltip}`} placement='bottom' arrow={false}>
      <EyeClosedImg data-qa-selector={qaSelector} {...rest} />
    </Tooltip>
  );
}

export default HideIcon;
